import { ColumnDef } from '@if/mui'
import { DevToolsCommandExecution } from '@src/types/dev-tools'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { EDevToolsExecutionStatus } from './dev-tools-status'

interface UseCommandHistoryColumnsOptions {
  includeErrorMessage: boolean
}

export const useCommandHistoryColumns = ({
  includeErrorMessage,
}: UseCommandHistoryColumnsOptions): ColumnDef<DevToolsCommandExecution>[] => {
  const { t } = useTranslation()

  return useMemo<ColumnDef<DevToolsCommandExecution>[]>(() => {
    const columns: ColumnDef<DevToolsCommandExecution>[] = [
      {
        name: 'executedOn',
        type: 'date',
        header: t('admin.devTools.history.columns.executedOn'),
        minWidth: 170,
      },
      {
        name: 'executedByUserFullname',
        type: 'title',
        header: t('admin.devTools.history.columns.user'),
        minWidth: 150,
        flexGrow: 1,
      },
      {
        name: 'status',
        type: 'enumChip',
        header: t('admin.devTools.history.columns.status'),
        set: EDevToolsExecutionStatus,
        getValue: (row) => (row.errorMessage ? EDevToolsExecutionStatus.Failed : EDevToolsExecutionStatus.Success),
        width: 130,
      },
    ]

    if (includeErrorMessage) {
      columns.push({
        name: 'errorMessage',
        type: 'string',
        header: t('admin.devTools.history.columns.errorMessage'),
        minWidth: 200,
        flexGrow: 2,
        wrap: true,
      })
    }

    return columns
  }, [includeErrorMessage, t])
}
